define((require) => {
    "use strict";

    const _      = require("underscore");
    const Effect = require("shared/ui/experience/action/effects/EffectModel");

    const TYPE = "rotate";
    const MODE = {
        Angle: "angle",
        Infinite: "infinite"
    };
    const DIRECTION = {
        Clockwise: "cw",
        Counterclockwise: "ccw"
    };

    return Effect.extend({
        defaults: _.defaults({
            type: TYPE,
            rotation: 10,
            attentionMode: MODE.Angle,
            rotationDirection: DIRECTION.Clockwise
        }, Effect.prototype.defaults)
    }, {
        TYPE,
        MODE,
        DIRECTION
    });
});



// WEBPACK FOOTER //
// ./src/shared/ui/experience/action/effects/RotateEffectModel.js